"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductToJSON = exports.ProductFromJSONTyped = exports.ProductFromJSON = exports.instanceOfProduct = exports.ProductDetailsProviderEnum = exports.ProductPlacementEnum = void 0;
var runtime_1 = require("../runtime");
var ProductVariantsInner_1 = require("./ProductVariantsInner");
var SizesInner_1 = require("./SizesInner");
/**
 * @export
 */
exports.ProductPlacementEnum = {
    FollowsDesign: 'placement_follows_design',
    Full: 'placement_full'
};
/**
 * @export
 */
exports.ProductDetailsProviderEnum = {
    Mms: 'mms',
    Donation: 'donation',
    AdminFee: 'admin_fee'
};
/**
 * Check if a given object implements the Product interface.
 */
function instanceOfProduct(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfProduct = instanceOfProduct;
function ProductFromJSON(json) {
    return ProductFromJSONTyped(json, false);
}
exports.ProductFromJSON = ProductFromJSON;
function ProductFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'storeId': !(0, runtime_1.exists)(json, 'store_id') ? undefined : json['store_id'],
        'active': !(0, runtime_1.exists)(json, 'active') ? undefined : json['active'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'styleId': !(0, runtime_1.exists)(json, 'style_id') ? undefined : json['style_id'],
        'price': !(0, runtime_1.exists)(json, 'price') ? undefined : json['price'],
        'position': !(0, runtime_1.exists)(json, 'position') ? undefined : json['position'],
        'imageUrl': !(0, runtime_1.exists)(json, 'image_url') ? undefined : json['image_url'],
        'limited': !(0, runtime_1.exists)(json, 'limited') ? undefined : json['limited'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'features': !(0, runtime_1.exists)(json, 'features') ? undefined : json['features'],
        'placement': !(0, runtime_1.exists)(json, 'placement') ? undefined : json['placement'],
        'minQuantity': !(0, runtime_1.exists)(json, 'min_quantity') ? undefined : json['min_quantity'],
        'originalPrice': !(0, runtime_1.exists)(json, 'original_price') ? undefined : json['original_price'],
        'detailsProvider': !(0, runtime_1.exists)(json, 'details_provider') ? undefined : json['details_provider'],
        'deliveryEstimate': !(0, runtime_1.exists)(json, 'delivery_estimate') ? undefined : json['delivery_estimate'],
        'elevateShipping': !(0, runtime_1.exists)(json, 'elevate_shipping') ? undefined : json['elevate_shipping'],
        'fulfillmentDate': !(0, runtime_1.exists)(json, 'fulfillment_date') ? undefined : json['fulfillment_date'],
        'sizeChart': !(0, runtime_1.exists)(json, 'size_chart') ? undefined : json['size_chart'],
        'sizeLineup': !(0, runtime_1.exists)(json, 'size_lineup') ? undefined : json['size_lineup'],
        'sizes': !(0, runtime_1.exists)(json, 'sizes') ? undefined : (json['sizes'].map(SizesInner_1.SizesInnerFromJSON)),
        'timeLeftToOrder': !(0, runtime_1.exists)(json, 'time_left_to_order') ? undefined : json['time_left_to_order'],
        'undecorated': !(0, runtime_1.exists)(json, 'undecorated') ? undefined : json['undecorated'],
        'variants': !(0, runtime_1.exists)(json, 'variants') ? undefined : (json['variants'].map(ProductVariantsInner_1.ProductVariantsInnerFromJSON)),
    };
}
exports.ProductFromJSONTyped = ProductFromJSONTyped;
function ProductToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'store_id': value.storeId,
        'active': value.active,
        'name': value.name,
        'style_id': value.styleId,
        'price': value.price,
        'position': value.position,
        'image_url': value.imageUrl,
        'limited': value.limited,
        'description': value.description,
        'features': value.features,
        'placement': value.placement,
        'min_quantity': value.minQuantity,
        'original_price': value.originalPrice,
        'details_provider': value.detailsProvider,
        'delivery_estimate': value.deliveryEstimate,
        'elevate_shipping': value.elevateShipping,
        'fulfillment_date': value.fulfillmentDate,
        'size_chart': value.sizeChart,
        'size_lineup': value.sizeLineup,
        'sizes': value.sizes === undefined ? undefined : (value.sizes.map(SizesInner_1.SizesInnerToJSON)),
        'time_left_to_order': value.timeLeftToOrder,
        'undecorated': value.undecorated,
        'variants': value.variants === undefined ? undefined : (value.variants.map(ProductVariantsInner_1.ProductVariantsInnerToJSON)),
    };
}
exports.ProductToJSON = ProductToJSON;
